export default __webpack_public_path__ + "static/media/inputInactiveURAT.4b8a0b5b.png";